/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { RadioType_Enum, radioType_EnumFromJSON, radioType_EnumToJSON } from "../../gen/handhawk_main/radio_type";
import { MicrohardLanSettingsPb } from "../../gen/microhard_util/microhard_lan_settings";
import {
  DeviceType_Enum,
  deviceType_EnumFromJSON,
  deviceType_EnumToJSON,
} from "../../gen/vehicle_attributes/device_type";

export const protobufPackage = "wifi";

export enum IpsecPolicy {
  DISABLED = 0,
  UPLINK_ONLY = 1,
  DOWNLINK_ONLY = 2,
  BIDIRECTIONAL = 3,
  UNRECOGNIZED = -1,
}

export function ipsecPolicyFromJSON(object: any): IpsecPolicy {
  switch (object) {
    case 0:
    case "DISABLED":
      return IpsecPolicy.DISABLED;
    case 1:
    case "UPLINK_ONLY":
      return IpsecPolicy.UPLINK_ONLY;
    case 2:
    case "DOWNLINK_ONLY":
      return IpsecPolicy.DOWNLINK_ONLY;
    case 3:
    case "BIDIRECTIONAL":
      return IpsecPolicy.BIDIRECTIONAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IpsecPolicy.UNRECOGNIZED;
  }
}

export function ipsecPolicyToJSON(object: IpsecPolicy): string {
  switch (object) {
    case IpsecPolicy.DISABLED:
      return "DISABLED";
    case IpsecPolicy.UPLINK_ONLY:
      return "UPLINK_ONLY";
    case IpsecPolicy.DOWNLINK_ONLY:
      return "DOWNLINK_ONLY";
    case IpsecPolicy.BIDIRECTIONAL:
      return "BIDIRECTIONAL";
    case IpsecPolicy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** States to report to client app that indicates Radio state */
export enum RadioState {
  UNKNOWN = 0,
  INITIALIZING = 1,
  READY = 2,
  UNRECOGNIZED = -1,
}

export function radioStateFromJSON(object: any): RadioState {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return RadioState.UNKNOWN;
    case 1:
    case "INITIALIZING":
      return RadioState.INITIALIZING;
    case 2:
    case "READY":
      return RadioState.READY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RadioState.UNRECOGNIZED;
  }
}

export function radioStateToJSON(object: RadioState): string {
  switch (object) {
    case RadioState.UNKNOWN:
      return "UNKNOWN";
    case RadioState.INITIALIZING:
      return "INITIALIZING";
    case RadioState.READY:
      return "READY";
    case RadioState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RadioConnectionState {
  kInvalid = 0,
  kUsbConnected = 1,
  kPairingInfoReceived = 2,
  kConnected = 3,
  kDisconnected = 4,
  kPairingTimeout = 5,
  UNRECOGNIZED = -1,
}

export function radioConnectionStateFromJSON(object: any): RadioConnectionState {
  switch (object) {
    case 0:
    case "kInvalid":
      return RadioConnectionState.kInvalid;
    case 1:
    case "kUsbConnected":
      return RadioConnectionState.kUsbConnected;
    case 2:
    case "kPairingInfoReceived":
      return RadioConnectionState.kPairingInfoReceived;
    case 3:
    case "kConnected":
      return RadioConnectionState.kConnected;
    case 4:
    case "kDisconnected":
      return RadioConnectionState.kDisconnected;
    case 5:
    case "kPairingTimeout":
      return RadioConnectionState.kPairingTimeout;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RadioConnectionState.UNRECOGNIZED;
  }
}

export function radioConnectionStateToJSON(object: RadioConnectionState): string {
  switch (object) {
    case RadioConnectionState.kInvalid:
      return "kInvalid";
    case RadioConnectionState.kUsbConnected:
      return "kUsbConnected";
    case RadioConnectionState.kPairingInfoReceived:
      return "kPairingInfoReceived";
    case RadioConnectionState.kConnected:
      return "kConnected";
    case RadioConnectionState.kDisconnected:
      return "kDisconnected";
    case RadioConnectionState.kPairingTimeout:
      return "kPairingTimeout";
    case RadioConnectionState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WifiCredentials {
  utime: number;
  /** Network id */
  networkId: string;
  bssid: string;
  /**
   * 256 bit key provided as 65 hex digits *or* Human readable passphrase between 8 and 63
   * characters
   */
  password: string;
  /** True if password represents psk. False if password represents passphrase */
  hashedPsk: boolean;
  /** Ipsec keys, only present if desired_ipsec matches */
  desiredIpsec: IpsecPolicy;
  uplinkEncKey: string;
  downlinkEncKey: string;
  uplinkAuthKey: string;
  downlinkAuthKey: string;
  macAddress: string;
}

export interface WifiCredentialsList {
  utime: number;
  wifiCredentials: WifiCredentials[];
  wifiCredentialsType: WifiCredentialsList_WifiCredentialsType;
}

export enum WifiCredentialsList_WifiCredentialsType {
  UNKNOWN = 0,
  INFRASTRUCTURE = 1,
  VEHICLE = 2,
  UNRECOGNIZED = -1,
}

export function wifiCredentialsList_WifiCredentialsTypeFromJSON(object: any): WifiCredentialsList_WifiCredentialsType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return WifiCredentialsList_WifiCredentialsType.UNKNOWN;
    case 1:
    case "INFRASTRUCTURE":
      return WifiCredentialsList_WifiCredentialsType.INFRASTRUCTURE;
    case 2:
    case "VEHICLE":
      return WifiCredentialsList_WifiCredentialsType.VEHICLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WifiCredentialsList_WifiCredentialsType.UNRECOGNIZED;
  }
}

export function wifiCredentialsList_WifiCredentialsTypeToJSON(object: WifiCredentialsList_WifiCredentialsType): string {
  switch (object) {
    case WifiCredentialsList_WifiCredentialsType.UNKNOWN:
      return "UNKNOWN";
    case WifiCredentialsList_WifiCredentialsType.INFRASTRUCTURE:
      return "INFRASTRUCTURE";
    case WifiCredentialsList_WifiCredentialsType.VEHICLE:
      return "VEHICLE";
    case WifiCredentialsList_WifiCredentialsType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SkysticksDeviceInfo {
  utime: number;
  serial: string;
  radioType: RadioType_Enum;
  desiredIpsec: IpsecPolicy;
  macAddress: string;
  deviceType: DeviceType_Enum;
  deviceInfoSwVersion: number;
}

export interface SkysticksPairingInfo {
  utime: number;
  vehicleName: string;
  vehicleSerial: string;
  radioType: RadioType_Enum;
  /**
   * Microhard uses network_id and passphrase.
   * All other fields skydiolink only.
   */
  credentials:
    | WifiCredentials
    | undefined;
  /** Microhard only */
  bandwidth: number;
  channel: number;
  band: number;
  mode: number;
  powerKnob: number;
  microhardLanSettings:
    | MicrohardLanSettingsPb
    | undefined;
  /** If pairing is for skysticks or third party */
  isNonSkysticksPairing: boolean;
  /** Attachment network */
  externalLanSettings: ExternalNetworkLanSettings | undefined;
}

/** Message to publish over skybus */
export interface SkysticksRadioStatus {
  utime: number;
  state: RadioState;
  vehicleRadioType: RadioType_Enum;
  controllerRadioType: RadioType_Enum;
}

export interface SkysticksBeaconTunnelStatus {
  ackTime: number;
  recvTime: number;
  sendTime: number;
  lastActivityTime: number;
}

export interface WifiViRetryRate {
  utime: number;
  /** Retry rate for VI category */
  viRetryRate: number;
  /** Average retry times per packet on vehicle */
  retryAvg: number;
  /** Average duplicate times per packet on controller */
  dupAvg: number;
}

export interface UplinkTbttModeConfig {
  utime: number;
  /** Current TBTT Mode on the vehicle */
  tbttMode: number;
  /** cadence needed for the tbtt mode */
  uplinkCadence: number;
  /** uplink packet size */
  uplinkPacketSize: number;
  /** NOTE(rhea) this is a temporary fix, this channel is supposed to be pine only generally. */
  isMh: boolean;
}

export interface AmtelecomDongleStatus {
  utime: number;
  /** dongle is detected or not */
  status: boolean;
}

export interface RadioClientStatus {
  utime: number;
  status: RadioConnectionState;
}

export interface ExternalNetworkLanSettings {
  vehicleIp: string;
}

function createBaseWifiCredentials(): WifiCredentials {
  return {
    utime: 0,
    networkId: "",
    bssid: "",
    password: "",
    hashedPsk: false,
    desiredIpsec: 0,
    uplinkEncKey: "",
    downlinkEncKey: "",
    uplinkAuthKey: "",
    downlinkAuthKey: "",
    macAddress: "",
  };
}

export const WifiCredentials = {
  encode(message: WifiCredentials, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.networkId !== "") {
      writer.uint32(18).string(message.networkId);
    }
    if (message.bssid !== "") {
      writer.uint32(26).string(message.bssid);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    if (message.hashedPsk === true) {
      writer.uint32(40).bool(message.hashedPsk);
    }
    if (message.desiredIpsec !== 0) {
      writer.uint32(48).int32(message.desiredIpsec);
    }
    if (message.uplinkEncKey !== "") {
      writer.uint32(58).string(message.uplinkEncKey);
    }
    if (message.downlinkEncKey !== "") {
      writer.uint32(66).string(message.downlinkEncKey);
    }
    if (message.uplinkAuthKey !== "") {
      writer.uint32(74).string(message.uplinkAuthKey);
    }
    if (message.downlinkAuthKey !== "") {
      writer.uint32(82).string(message.downlinkAuthKey);
    }
    if (message.macAddress !== "") {
      writer.uint32(90).string(message.macAddress);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiCredentials {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiCredentials();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.networkId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.bssid = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.hashedPsk = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.desiredIpsec = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.uplinkEncKey = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.downlinkEncKey = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.uplinkAuthKey = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.downlinkAuthKey = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.macAddress = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WifiCredentials {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      networkId: isSet(object.networkId) ? globalThis.String(object.networkId) : "",
      bssid: isSet(object.bssid) ? globalThis.String(object.bssid) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      hashedPsk: isSet(object.hashedPsk) ? globalThis.Boolean(object.hashedPsk) : false,
      desiredIpsec: isSet(object.desiredIpsec) ? ipsecPolicyFromJSON(object.desiredIpsec) : 0,
      uplinkEncKey: isSet(object.uplinkEncKey) ? globalThis.String(object.uplinkEncKey) : "",
      downlinkEncKey: isSet(object.downlinkEncKey) ? globalThis.String(object.downlinkEncKey) : "",
      uplinkAuthKey: isSet(object.uplinkAuthKey) ? globalThis.String(object.uplinkAuthKey) : "",
      downlinkAuthKey: isSet(object.downlinkAuthKey) ? globalThis.String(object.downlinkAuthKey) : "",
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
    };
  },

  toJSON(message: WifiCredentials): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.networkId !== "") {
      obj.networkId = message.networkId;
    }
    if (message.bssid !== "") {
      obj.bssid = message.bssid;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.hashedPsk === true) {
      obj.hashedPsk = message.hashedPsk;
    }
    if (message.desiredIpsec !== 0) {
      obj.desiredIpsec = ipsecPolicyToJSON(message.desiredIpsec);
    }
    if (message.uplinkEncKey !== "") {
      obj.uplinkEncKey = message.uplinkEncKey;
    }
    if (message.downlinkEncKey !== "") {
      obj.downlinkEncKey = message.downlinkEncKey;
    }
    if (message.uplinkAuthKey !== "") {
      obj.uplinkAuthKey = message.uplinkAuthKey;
    }
    if (message.downlinkAuthKey !== "") {
      obj.downlinkAuthKey = message.downlinkAuthKey;
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiCredentials>, I>>(base?: I): WifiCredentials {
    return WifiCredentials.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiCredentials>, I>>(object: I): WifiCredentials {
    const message = createBaseWifiCredentials();
    message.utime = object.utime ?? 0;
    message.networkId = object.networkId ?? "";
    message.bssid = object.bssid ?? "";
    message.password = object.password ?? "";
    message.hashedPsk = object.hashedPsk ?? false;
    message.desiredIpsec = object.desiredIpsec ?? 0;
    message.uplinkEncKey = object.uplinkEncKey ?? "";
    message.downlinkEncKey = object.downlinkEncKey ?? "";
    message.uplinkAuthKey = object.uplinkAuthKey ?? "";
    message.downlinkAuthKey = object.downlinkAuthKey ?? "";
    message.macAddress = object.macAddress ?? "";
    return message;
  },
};

function createBaseWifiCredentialsList(): WifiCredentialsList {
  return { utime: 0, wifiCredentials: [], wifiCredentialsType: 0 };
}

export const WifiCredentialsList = {
  encode(message: WifiCredentialsList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    for (const v of message.wifiCredentials) {
      WifiCredentials.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.wifiCredentialsType !== 0) {
      writer.uint32(24).int32(message.wifiCredentialsType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiCredentialsList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiCredentialsList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.wifiCredentials.push(WifiCredentials.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.wifiCredentialsType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WifiCredentialsList {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      wifiCredentials: globalThis.Array.isArray(object?.wifiCredentials)
        ? object.wifiCredentials.map((e: any) => WifiCredentials.fromJSON(e))
        : [],
      wifiCredentialsType: isSet(object.wifiCredentialsType)
        ? wifiCredentialsList_WifiCredentialsTypeFromJSON(object.wifiCredentialsType)
        : 0,
    };
  },

  toJSON(message: WifiCredentialsList): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.wifiCredentials?.length) {
      obj.wifiCredentials = message.wifiCredentials.map((e) => WifiCredentials.toJSON(e));
    }
    if (message.wifiCredentialsType !== 0) {
      obj.wifiCredentialsType = wifiCredentialsList_WifiCredentialsTypeToJSON(message.wifiCredentialsType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiCredentialsList>, I>>(base?: I): WifiCredentialsList {
    return WifiCredentialsList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiCredentialsList>, I>>(object: I): WifiCredentialsList {
    const message = createBaseWifiCredentialsList();
    message.utime = object.utime ?? 0;
    message.wifiCredentials = object.wifiCredentials?.map((e) => WifiCredentials.fromPartial(e)) || [];
    message.wifiCredentialsType = object.wifiCredentialsType ?? 0;
    return message;
  },
};

function createBaseSkysticksDeviceInfo(): SkysticksDeviceInfo {
  return { utime: 0, serial: "", radioType: 0, desiredIpsec: 0, macAddress: "", deviceType: 0, deviceInfoSwVersion: 0 };
}

export const SkysticksDeviceInfo = {
  encode(message: SkysticksDeviceInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.serial !== "") {
      writer.uint32(18).string(message.serial);
    }
    if (message.radioType !== 0) {
      writer.uint32(24).int32(message.radioType);
    }
    if (message.desiredIpsec !== 0) {
      writer.uint32(32).int32(message.desiredIpsec);
    }
    if (message.macAddress !== "") {
      writer.uint32(42).string(message.macAddress);
    }
    if (message.deviceType !== 0) {
      writer.uint32(48).int32(message.deviceType);
    }
    if (message.deviceInfoSwVersion !== 0) {
      writer.uint32(56).int32(message.deviceInfoSwVersion);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkysticksDeviceInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkysticksDeviceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.radioType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.desiredIpsec = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.macAddress = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.deviceInfoSwVersion = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkysticksDeviceInfo {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      radioType: isSet(object.radioType) ? radioType_EnumFromJSON(object.radioType) : 0,
      desiredIpsec: isSet(object.desiredIpsec) ? ipsecPolicyFromJSON(object.desiredIpsec) : 0,
      macAddress: isSet(object.macAddress) ? globalThis.String(object.macAddress) : "",
      deviceType: isSet(object.deviceType) ? deviceType_EnumFromJSON(object.deviceType) : 0,
      deviceInfoSwVersion: isSet(object.deviceInfoSwVersion) ? globalThis.Number(object.deviceInfoSwVersion) : 0,
    };
  },

  toJSON(message: SkysticksDeviceInfo): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.radioType !== 0) {
      obj.radioType = radioType_EnumToJSON(message.radioType);
    }
    if (message.desiredIpsec !== 0) {
      obj.desiredIpsec = ipsecPolicyToJSON(message.desiredIpsec);
    }
    if (message.macAddress !== "") {
      obj.macAddress = message.macAddress;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = deviceType_EnumToJSON(message.deviceType);
    }
    if (message.deviceInfoSwVersion !== 0) {
      obj.deviceInfoSwVersion = Math.round(message.deviceInfoSwVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkysticksDeviceInfo>, I>>(base?: I): SkysticksDeviceInfo {
    return SkysticksDeviceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkysticksDeviceInfo>, I>>(object: I): SkysticksDeviceInfo {
    const message = createBaseSkysticksDeviceInfo();
    message.utime = object.utime ?? 0;
    message.serial = object.serial ?? "";
    message.radioType = object.radioType ?? 0;
    message.desiredIpsec = object.desiredIpsec ?? 0;
    message.macAddress = object.macAddress ?? "";
    message.deviceType = object.deviceType ?? 0;
    message.deviceInfoSwVersion = object.deviceInfoSwVersion ?? 0;
    return message;
  },
};

function createBaseSkysticksPairingInfo(): SkysticksPairingInfo {
  return {
    utime: 0,
    vehicleName: "",
    vehicleSerial: "",
    radioType: 0,
    credentials: undefined,
    bandwidth: 0,
    channel: 0,
    band: 0,
    mode: 0,
    powerKnob: 0,
    microhardLanSettings: undefined,
    isNonSkysticksPairing: false,
    externalLanSettings: undefined,
  };
}

export const SkysticksPairingInfo = {
  encode(message: SkysticksPairingInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.vehicleName !== "") {
      writer.uint32(18).string(message.vehicleName);
    }
    if (message.vehicleSerial !== "") {
      writer.uint32(106).string(message.vehicleSerial);
    }
    if (message.radioType !== 0) {
      writer.uint32(24).int32(message.radioType);
    }
    if (message.credentials !== undefined) {
      WifiCredentials.encode(message.credentials, writer.uint32(34).fork()).ldelim();
    }
    if (message.bandwidth !== 0) {
      writer.uint32(64).int32(message.bandwidth);
    }
    if (message.channel !== 0) {
      writer.uint32(72).int32(message.channel);
    }
    if (message.band !== 0) {
      writer.uint32(80).int32(message.band);
    }
    if (message.mode !== 0) {
      writer.uint32(88).int32(message.mode);
    }
    if (message.powerKnob !== 0) {
      writer.uint32(96).int32(message.powerKnob);
    }
    if (message.microhardLanSettings !== undefined) {
      MicrohardLanSettingsPb.encode(message.microhardLanSettings, writer.uint32(122).fork()).ldelim();
    }
    if (message.isNonSkysticksPairing === true) {
      writer.uint32(112).bool(message.isNonSkysticksPairing);
    }
    if (message.externalLanSettings !== undefined) {
      ExternalNetworkLanSettings.encode(message.externalLanSettings, writer.uint32(130).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkysticksPairingInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkysticksPairingInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.vehicleName = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.vehicleSerial = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.radioType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.credentials = WifiCredentials.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.bandwidth = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.channel = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.band = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.mode = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.powerKnob = reader.int32();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.microhardLanSettings = MicrohardLanSettingsPb.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.isNonSkysticksPairing = reader.bool();
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.externalLanSettings = ExternalNetworkLanSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkysticksPairingInfo {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      vehicleName: isSet(object.vehicleName) ? globalThis.String(object.vehicleName) : "",
      vehicleSerial: isSet(object.vehicleSerial) ? globalThis.String(object.vehicleSerial) : "",
      radioType: isSet(object.radioType) ? radioType_EnumFromJSON(object.radioType) : 0,
      credentials: isSet(object.credentials) ? WifiCredentials.fromJSON(object.credentials) : undefined,
      bandwidth: isSet(object.bandwidth) ? globalThis.Number(object.bandwidth) : 0,
      channel: isSet(object.channel) ? globalThis.Number(object.channel) : 0,
      band: isSet(object.band) ? globalThis.Number(object.band) : 0,
      mode: isSet(object.mode) ? globalThis.Number(object.mode) : 0,
      powerKnob: isSet(object.powerKnob) ? globalThis.Number(object.powerKnob) : 0,
      microhardLanSettings: isSet(object.microhardLanSettings)
        ? MicrohardLanSettingsPb.fromJSON(object.microhardLanSettings)
        : undefined,
      isNonSkysticksPairing: isSet(object.isNonSkysticksPairing)
        ? globalThis.Boolean(object.isNonSkysticksPairing)
        : false,
      externalLanSettings: isSet(object.externalLanSettings)
        ? ExternalNetworkLanSettings.fromJSON(object.externalLanSettings)
        : undefined,
    };
  },

  toJSON(message: SkysticksPairingInfo): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.vehicleName !== "") {
      obj.vehicleName = message.vehicleName;
    }
    if (message.vehicleSerial !== "") {
      obj.vehicleSerial = message.vehicleSerial;
    }
    if (message.radioType !== 0) {
      obj.radioType = radioType_EnumToJSON(message.radioType);
    }
    if (message.credentials !== undefined) {
      obj.credentials = WifiCredentials.toJSON(message.credentials);
    }
    if (message.bandwidth !== 0) {
      obj.bandwidth = Math.round(message.bandwidth);
    }
    if (message.channel !== 0) {
      obj.channel = Math.round(message.channel);
    }
    if (message.band !== 0) {
      obj.band = Math.round(message.band);
    }
    if (message.mode !== 0) {
      obj.mode = Math.round(message.mode);
    }
    if (message.powerKnob !== 0) {
      obj.powerKnob = Math.round(message.powerKnob);
    }
    if (message.microhardLanSettings !== undefined) {
      obj.microhardLanSettings = MicrohardLanSettingsPb.toJSON(message.microhardLanSettings);
    }
    if (message.isNonSkysticksPairing === true) {
      obj.isNonSkysticksPairing = message.isNonSkysticksPairing;
    }
    if (message.externalLanSettings !== undefined) {
      obj.externalLanSettings = ExternalNetworkLanSettings.toJSON(message.externalLanSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkysticksPairingInfo>, I>>(base?: I): SkysticksPairingInfo {
    return SkysticksPairingInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkysticksPairingInfo>, I>>(object: I): SkysticksPairingInfo {
    const message = createBaseSkysticksPairingInfo();
    message.utime = object.utime ?? 0;
    message.vehicleName = object.vehicleName ?? "";
    message.vehicleSerial = object.vehicleSerial ?? "";
    message.radioType = object.radioType ?? 0;
    message.credentials = (object.credentials !== undefined && object.credentials !== null)
      ? WifiCredentials.fromPartial(object.credentials)
      : undefined;
    message.bandwidth = object.bandwidth ?? 0;
    message.channel = object.channel ?? 0;
    message.band = object.band ?? 0;
    message.mode = object.mode ?? 0;
    message.powerKnob = object.powerKnob ?? 0;
    message.microhardLanSettings = (object.microhardLanSettings !== undefined && object.microhardLanSettings !== null)
      ? MicrohardLanSettingsPb.fromPartial(object.microhardLanSettings)
      : undefined;
    message.isNonSkysticksPairing = object.isNonSkysticksPairing ?? false;
    message.externalLanSettings = (object.externalLanSettings !== undefined && object.externalLanSettings !== null)
      ? ExternalNetworkLanSettings.fromPartial(object.externalLanSettings)
      : undefined;
    return message;
  },
};

function createBaseSkysticksRadioStatus(): SkysticksRadioStatus {
  return { utime: 0, state: 0, vehicleRadioType: 0, controllerRadioType: 0 };
}

export const SkysticksRadioStatus = {
  encode(message: SkysticksRadioStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.vehicleRadioType !== 0) {
      writer.uint32(24).int32(message.vehicleRadioType);
    }
    if (message.controllerRadioType !== 0) {
      writer.uint32(32).int32(message.controllerRadioType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkysticksRadioStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkysticksRadioStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.vehicleRadioType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.controllerRadioType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkysticksRadioStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      state: isSet(object.state) ? radioStateFromJSON(object.state) : 0,
      vehicleRadioType: isSet(object.vehicleRadioType) ? radioType_EnumFromJSON(object.vehicleRadioType) : 0,
      controllerRadioType: isSet(object.controllerRadioType) ? radioType_EnumFromJSON(object.controllerRadioType) : 0,
    };
  },

  toJSON(message: SkysticksRadioStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.state !== 0) {
      obj.state = radioStateToJSON(message.state);
    }
    if (message.vehicleRadioType !== 0) {
      obj.vehicleRadioType = radioType_EnumToJSON(message.vehicleRadioType);
    }
    if (message.controllerRadioType !== 0) {
      obj.controllerRadioType = radioType_EnumToJSON(message.controllerRadioType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkysticksRadioStatus>, I>>(base?: I): SkysticksRadioStatus {
    return SkysticksRadioStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkysticksRadioStatus>, I>>(object: I): SkysticksRadioStatus {
    const message = createBaseSkysticksRadioStatus();
    message.utime = object.utime ?? 0;
    message.state = object.state ?? 0;
    message.vehicleRadioType = object.vehicleRadioType ?? 0;
    message.controllerRadioType = object.controllerRadioType ?? 0;
    return message;
  },
};

function createBaseSkysticksBeaconTunnelStatus(): SkysticksBeaconTunnelStatus {
  return { ackTime: 0, recvTime: 0, sendTime: 0, lastActivityTime: 0 };
}

export const SkysticksBeaconTunnelStatus = {
  encode(message: SkysticksBeaconTunnelStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ackTime !== 0) {
      writer.uint32(8).int64(message.ackTime);
    }
    if (message.recvTime !== 0) {
      writer.uint32(16).int64(message.recvTime);
    }
    if (message.sendTime !== 0) {
      writer.uint32(24).int64(message.sendTime);
    }
    if (message.lastActivityTime !== 0) {
      writer.uint32(32).int64(message.lastActivityTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkysticksBeaconTunnelStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkysticksBeaconTunnelStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.ackTime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.recvTime = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.sendTime = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.lastActivityTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkysticksBeaconTunnelStatus {
    return {
      ackTime: isSet(object.ackTime) ? globalThis.Number(object.ackTime) : 0,
      recvTime: isSet(object.recvTime) ? globalThis.Number(object.recvTime) : 0,
      sendTime: isSet(object.sendTime) ? globalThis.Number(object.sendTime) : 0,
      lastActivityTime: isSet(object.lastActivityTime) ? globalThis.Number(object.lastActivityTime) : 0,
    };
  },

  toJSON(message: SkysticksBeaconTunnelStatus): unknown {
    const obj: any = {};
    if (message.ackTime !== 0) {
      obj.ackTime = Math.round(message.ackTime);
    }
    if (message.recvTime !== 0) {
      obj.recvTime = Math.round(message.recvTime);
    }
    if (message.sendTime !== 0) {
      obj.sendTime = Math.round(message.sendTime);
    }
    if (message.lastActivityTime !== 0) {
      obj.lastActivityTime = Math.round(message.lastActivityTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkysticksBeaconTunnelStatus>, I>>(base?: I): SkysticksBeaconTunnelStatus {
    return SkysticksBeaconTunnelStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkysticksBeaconTunnelStatus>, I>>(object: I): SkysticksBeaconTunnelStatus {
    const message = createBaseSkysticksBeaconTunnelStatus();
    message.ackTime = object.ackTime ?? 0;
    message.recvTime = object.recvTime ?? 0;
    message.sendTime = object.sendTime ?? 0;
    message.lastActivityTime = object.lastActivityTime ?? 0;
    return message;
  },
};

function createBaseWifiViRetryRate(): WifiViRetryRate {
  return { utime: 0, viRetryRate: 0, retryAvg: 0, dupAvg: 0 };
}

export const WifiViRetryRate = {
  encode(message: WifiViRetryRate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.viRetryRate !== 0) {
      writer.uint32(16).uint32(message.viRetryRate);
    }
    if (message.retryAvg !== 0) {
      writer.uint32(29).float(message.retryAvg);
    }
    if (message.dupAvg !== 0) {
      writer.uint32(37).float(message.dupAvg);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiViRetryRate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiViRetryRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.viRetryRate = reader.uint32();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.retryAvg = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.dupAvg = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WifiViRetryRate {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      viRetryRate: isSet(object.viRetryRate) ? globalThis.Number(object.viRetryRate) : 0,
      retryAvg: isSet(object.retryAvg) ? globalThis.Number(object.retryAvg) : 0,
      dupAvg: isSet(object.dupAvg) ? globalThis.Number(object.dupAvg) : 0,
    };
  },

  toJSON(message: WifiViRetryRate): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.viRetryRate !== 0) {
      obj.viRetryRate = Math.round(message.viRetryRate);
    }
    if (message.retryAvg !== 0) {
      obj.retryAvg = message.retryAvg;
    }
    if (message.dupAvg !== 0) {
      obj.dupAvg = message.dupAvg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiViRetryRate>, I>>(base?: I): WifiViRetryRate {
    return WifiViRetryRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiViRetryRate>, I>>(object: I): WifiViRetryRate {
    const message = createBaseWifiViRetryRate();
    message.utime = object.utime ?? 0;
    message.viRetryRate = object.viRetryRate ?? 0;
    message.retryAvg = object.retryAvg ?? 0;
    message.dupAvg = object.dupAvg ?? 0;
    return message;
  },
};

function createBaseUplinkTbttModeConfig(): UplinkTbttModeConfig {
  return { utime: 0, tbttMode: 0, uplinkCadence: 0, uplinkPacketSize: 0, isMh: false };
}

export const UplinkTbttModeConfig = {
  encode(message: UplinkTbttModeConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.tbttMode !== 0) {
      writer.uint32(16).uint32(message.tbttMode);
    }
    if (message.uplinkCadence !== 0) {
      writer.uint32(24).uint32(message.uplinkCadence);
    }
    if (message.uplinkPacketSize !== 0) {
      writer.uint32(32).uint32(message.uplinkPacketSize);
    }
    if (message.isMh === true) {
      writer.uint32(40).bool(message.isMh);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UplinkTbttModeConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUplinkTbttModeConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.tbttMode = reader.uint32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.uplinkCadence = reader.uint32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.uplinkPacketSize = reader.uint32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.isMh = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UplinkTbttModeConfig {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      tbttMode: isSet(object.tbttMode) ? globalThis.Number(object.tbttMode) : 0,
      uplinkCadence: isSet(object.uplinkCadence) ? globalThis.Number(object.uplinkCadence) : 0,
      uplinkPacketSize: isSet(object.uplinkPacketSize) ? globalThis.Number(object.uplinkPacketSize) : 0,
      isMh: isSet(object.isMh) ? globalThis.Boolean(object.isMh) : false,
    };
  },

  toJSON(message: UplinkTbttModeConfig): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.tbttMode !== 0) {
      obj.tbttMode = Math.round(message.tbttMode);
    }
    if (message.uplinkCadence !== 0) {
      obj.uplinkCadence = Math.round(message.uplinkCadence);
    }
    if (message.uplinkPacketSize !== 0) {
      obj.uplinkPacketSize = Math.round(message.uplinkPacketSize);
    }
    if (message.isMh === true) {
      obj.isMh = message.isMh;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UplinkTbttModeConfig>, I>>(base?: I): UplinkTbttModeConfig {
    return UplinkTbttModeConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UplinkTbttModeConfig>, I>>(object: I): UplinkTbttModeConfig {
    const message = createBaseUplinkTbttModeConfig();
    message.utime = object.utime ?? 0;
    message.tbttMode = object.tbttMode ?? 0;
    message.uplinkCadence = object.uplinkCadence ?? 0;
    message.uplinkPacketSize = object.uplinkPacketSize ?? 0;
    message.isMh = object.isMh ?? false;
    return message;
  },
};

function createBaseAmtelecomDongleStatus(): AmtelecomDongleStatus {
  return { utime: 0, status: false };
}

export const AmtelecomDongleStatus = {
  encode(message: AmtelecomDongleStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.status === true) {
      writer.uint32(16).bool(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AmtelecomDongleStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAmtelecomDongleStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AmtelecomDongleStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      status: isSet(object.status) ? globalThis.Boolean(object.status) : false,
    };
  },

  toJSON(message: AmtelecomDongleStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.status === true) {
      obj.status = message.status;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AmtelecomDongleStatus>, I>>(base?: I): AmtelecomDongleStatus {
    return AmtelecomDongleStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AmtelecomDongleStatus>, I>>(object: I): AmtelecomDongleStatus {
    const message = createBaseAmtelecomDongleStatus();
    message.utime = object.utime ?? 0;
    message.status = object.status ?? false;
    return message;
  },
};

function createBaseRadioClientStatus(): RadioClientStatus {
  return { utime: 0, status: 0 };
}

export const RadioClientStatus = {
  encode(message: RadioClientStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RadioClientStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRadioClientStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RadioClientStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      status: isSet(object.status) ? radioConnectionStateFromJSON(object.status) : 0,
    };
  },

  toJSON(message: RadioClientStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.status !== 0) {
      obj.status = radioConnectionStateToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RadioClientStatus>, I>>(base?: I): RadioClientStatus {
    return RadioClientStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RadioClientStatus>, I>>(object: I): RadioClientStatus {
    const message = createBaseRadioClientStatus();
    message.utime = object.utime ?? 0;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseExternalNetworkLanSettings(): ExternalNetworkLanSettings {
  return { vehicleIp: "" };
}

export const ExternalNetworkLanSettings = {
  encode(message: ExternalNetworkLanSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vehicleIp !== "") {
      writer.uint32(10).string(message.vehicleIp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExternalNetworkLanSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalNetworkLanSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.vehicleIp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalNetworkLanSettings {
    return { vehicleIp: isSet(object.vehicleIp) ? globalThis.String(object.vehicleIp) : "" };
  },

  toJSON(message: ExternalNetworkLanSettings): unknown {
    const obj: any = {};
    if (message.vehicleIp !== "") {
      obj.vehicleIp = message.vehicleIp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExternalNetworkLanSettings>, I>>(base?: I): ExternalNetworkLanSettings {
    return ExternalNetworkLanSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExternalNetworkLanSettings>, I>>(object: I): ExternalNetworkLanSettings {
    const message = createBaseExternalNetworkLanSettings();
    message.vehicleIp = object.vehicleIp ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
